import {Injectable} from '@angular/core';
import { LoggedUserModel } from '../models';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoggedUserService {
  private _currentUser = new BehaviorSubject<LoggedUserModel | null>(null);

  get currentUser(): Observable<LoggedUserModel | null> {
    return this._currentUser.asObservable();
  }

  setLoggedUser(user: LoggedUserModel | null) {
    this._currentUser.next(user);
  }

  get loggedUser(): LoggedUserModel | null {
    return this._currentUser.getValue();
  }
}
